import { useEffect, useRef, useState, forwardRef } from 'react'
import {DatePicker, Form, Input, message, Select, TreeSelect} from 'antd';
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SDrawerOrModal, SLocalTreeSelected, SMessage,
} from 'shj-components'
import { useSetState } from 'ahooks'
import { config } from '../config/FourthConfig.tsx'
import {
   goodsManagementGoodsPayeeConfDeleteInfoById,
  goodsManagementGoodsPayeeConfPage, goodsManagementGoodsPayeeConfSave
} from "@/services/goods.ts";
import {apiData2Table} from "@/utils/data.ts";
import {httpOrgList} from "@/services/homeService.ts";
import {isEmpty} from "lodash-es";
import dayjs from "dayjs";
import {getRulesPlanMainPage} from "@/services/fmsServices.ts";
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";

const FourthContent = forwardRef((props: any, ref) => {
  const {goodsId, copyId} = props;
  const [state, setState] = useSetState({
    treeData: [], // 左侧树形结构数据
    brandList: [], // 品牌
    categoryCode: null, // 当前选中品类code
    companyList: [],
    loading: false,
  })
  const listRef = useRef()
  const [record, setRecord] = useState<any>({})
  const [ form ] = Form.useForm();
  const [getMoneyRuleModal, setGetMoneyRuleModal] = useState(false)

  useEffect(() => {
    form.resetFields()
    if(!isEmpty(record)) {
      form.setFieldsValue({
        ...record,
        orgIdList: [record.orgId],
        startDate: record.startDate ? dayjs(record.startDate) : null,
        endDate: record.endDate ? dayjs(record.endDate) : null,
      });
    }
  }, [record]);

  useEffect(() => {
    listRef.current?.reload()
  }, [goodsId, copyId]);

  //   右侧数据查询
  const fetchList = ({current, pageSize, query}) => {
    if (!goodsId && !copyId) return Promise.reject()
    return new Promise((resolve, reject) => {
      goodsManagementGoodsPayeeConfPage({params: {current, pageSize}, data: {...query, goodsId: copyId || goodsId}}).then((res:any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  //   右侧下拉选项加载
  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    setState({companyList: [{name: '通用', id: '0'}, ...companyList]})
    return Promise.resolve({companyList: [{name: '通用', id: '0'}, ...companyList]})
  }

  // 右侧表格事件：
  const onAdd = () => {
    setGetMoneyRuleModal(true)
  }

  const onEdit = (record = {}) => {
    setGetMoneyRuleModal(true);
    setRecord(record)
  }

  const onDelete = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return goodsManagementGoodsPayeeConfDeleteInfoById({id, goodsId}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      setState({loading: true})
      const values_ = {
        ...values,
        startDate: values.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : undefined,
        endDate: values.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : undefined,
        goodsId
      }
      goodsManagementGoodsPayeeConfSave(values_).then(res => {
        message.success(res.message || '操作成功');
        setRecord({})
        setGetMoneyRuleModal(false)
        listRef.current?.reload()
      }).finally(() => setState({loading: false}))
    })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd, onEdit, onDelete },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              编辑
            </SActionBtn>
            <SActionBtn onClick={() => onDelete(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '100%'}}>
      {/* 右侧数据表格 */}
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        mode="modal"
        open={getMoneyRuleModal}
        onCancel={() => {
          setGetMoneyRuleModal(false)
          setRecord({})
        }}
        onOk={onSubmit}
        title={(record.id ? '编辑' : '新增') + '收款规则配置'}
        width={500}
        loading={state.loading}
      >
        <Form
          form={form}
          layout="vertical"
          name="basicInfo"
        >
          <Form.Item hidden name='id'><Input/></Form.Item>
          <Form.Item
            name="payRuleId"
            label="收款规则"
            rules={[
              {
                required: true,
                message: '请选择收款规则',
              },
            ]}
          >
            <DebounceSearchSelect label={'收款规则'} fetchOptions={getRulesPlanMainPage} query={{id: record?.payRuleId}}/>
          </Form.Item>
          <Form.Item
              name={record?.id ? 'orgId' : "orgIdList"}
              label="适用门店"
              rules={[
                {
                  required: true,
                  message: '请选择适用门店',
                },
              ]}
          >
            <SLocalTreeSelected placeholder={'请选择适用门店'} treeCheckable={!record.id} treeDefaultExpandAll
                                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                                fieldNames={{label: 'name', value: 'id'}}
                                treeData={state.companyList}/>
          </Form.Item>
          <Form.Item
              name="startDate"
              label="开始日期"
              rules={[
                {
                  required: true,
                  message: '请填写开始日期',
                },
              ]}
          >
            <DatePicker style={{width: '100%'}}/>
          </Form.Item>
          <Form.Item
              name="endDate"
              label="结束日期"
          >
            <DatePicker style={{width: '100%'}}
                        disabledDate={(current) => {
                          const startDate = form.getFieldValue('startDate')
                          if (startDate) return current && current < dayjs(startDate).endOf('day');
                        }}
            />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
});
export default FourthContent;
